import { takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};

function* getCurationProductsList(actions) {
  const uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-curation-product?page=" + actions.page
        : apiUrl + "/opa-curation-products" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);
    yield put({ type: "LIST_CURATION_PRODUCTS_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "LIST_CURATION_PRODUCTS_RESPONSE_GET", value: error });
  }
}

function* getCurationProductId(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = `${apiUrl}/opa-curation-product/${actions.query}`;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "CURATION_PRODUCT_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "CURATION_PRODUCT_RESPONSE_GET", value: error });
  }
}

function* getCurationFeaturedList(actions) {
  const uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-curation-featured-activity?page=" + actions.page
        : apiUrl + "/opa-curation-featured-activities" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);
    yield put({
      type: "LIST_CURATION_FEATURED_ACTIVITIES_RESPONSE_GET",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "LIST_CURATION_FEATURED_ACTIVITIES_RESPONSE_GET",
      value: error,
    });
  }
}

function* getCurationFeaturedId(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = `${apiUrl}/opa-curation-featured-activity/${actions.query}`;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({
      type: "CURATION_FEATURED_ACTIVITY_RESPONSE_GET",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "CURATION_FEATURED_ACTIVITY_RESPONSE_GET",
      value: error,
    });
  }
}

function* addCurationFeaturedActivity(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-curation-featured-activity";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.createdAt || response.uuid) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "CURATION_FEATURED_ACTIVITY_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "CURATION_FEATURED_ACTIVITY_RESPONSE_ADD",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}
function* updateCurationFeaturedActivity(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const formData = { ...actions.form };

    if (formData.uuid) {
      delete formData.uuid;
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(formData),
    };
    let url = `${apiUrl}/opa-curation-featured-activity/${actions.uuid}`;

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.updatedAt || response.uuid) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "CURATION_FEATURED_ACTIVITY_RESPONSE_UPDATE",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "CURATION_FEATURED_ACTIVITY_RESPONSE_UPDATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}
function* deleteCurationFeaturedActivity(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };
    let url = apiUrl + "/opa-curation-featured-activity/" + actions.uuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "CURATION_FEATURED_ACTIVITY_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "CURATION_FEATURED_ACTIVITY_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* getCurationExcludedList(actions) {
  const uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-curation-excluded-activity?page=" + actions.page
        : apiUrl + "/opa-curation-excluded-activities" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);
    yield put({
      type: "LIST_CURATION_EXCLUDED_ACTIVITIES_RESPONSE_GET",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "LIST_CURATION_EXCLUDED_ACTIVITIES_RESPONSE_GET",
      value: error,
    });
  }
}

function* getCurationExcludedId(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = `${apiUrl}/opa-curation-excluded-activity/${actions.query}`;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({
      type: "CURATION_EXCLUDED_ACTIVITY_RESPONSE_GET",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "CURATION_EXCLUDED_ACTIVITY_RESPONSE_GET",
      value: error,
    });
  }
}

function* addCurationExcludedActivity(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-curation-excluded-activity";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.createdAt || response.uuid) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "CURATION_EXCLUDED_ACTIVITY_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "CURATION_EXCLUDED_ACTIVITY_RESPONSE_ADD",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* deleteCurationExcludedActivity(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };
    let url = apiUrl + "/opa-curation-excluded-activity/" + actions.uuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "CURATION_EXCLUDED_ACTIVITY_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "CURATION_EXCLUDED_ACTIVITY_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* addCurationExcludedActivitiesAll(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-curation-excluded-activities";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.length > 0) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "CURATION_EXCLUDED_ACTIVITIES_ALL_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "CURATION_EXCLUDED_ACTIVITIES_ALL_RESPONSE_ADD",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* deleteCurationExcludedActivitiesAll(actions) {

  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.payload),
    };

    let url = apiUrl + "/opa-curation-excluded-activities";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "CURATION_EXCLUDED_ACTIVITIES_ALL_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "CURATION_EXCLUDED_ACTIVITIES_ALL_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}
function* addCurationFeaturedActivitiesAll(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-curation-featured-activities";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.length > 0) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "CURATION_FEATURED_ACTIVITIES_ALL_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "CURATION_FEATURED_ACTIVITIES_ALL_RESPONSE_ADD",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* deleteCurationFeaturedActivitiesAll(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-curation-featured-activities";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "CURATION_FEATURED_ACTIVITIES_ALL_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "CURATION_FEATURED_ACTIVITIES_ALL_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}


function* getCurationManagerActivitiesList(actions) {

  const uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-curation-manager-activities?page=" + actions.page
        : apiUrl + "/opa-curation-manager-activities" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);
    yield put({ type: "LIST_CURATION_MANAGER_ACTIVITIES_RESPONSE", value: response });
  } catch (error) {
    yield put({ type: "LIST_CURATION_MANAGER_ACTIVITIES_RESPONSE", value: error });
  }
}

function* getCurationManagerExclusionActivitiesList(actions) {
  const uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-curation-manager-exclusion-activities?page=" + actions.page
        : apiUrl + "/opa-curation-manager-exclusion-activities" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);
    yield put({ type: "LIST_CURATION_MANAGER_EXCLUSION_ACTIVITIES_RESPONSE", value: response });
  } catch (error) {
    yield put({ type: "LIST_CURATION_MANAGER_EXCLUSION_ACTIVITIES_RESPONSE", value: error });
  }
}

function* updateCurationManagerExclusionActivities(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const formData = { ...actions.form };

    if (formData.uuid) {
      delete formData.uuid;
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(formData),
    };
    let url = `${apiUrl}/opa-curation-manager-exclusion-activities`;

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response?.id) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "MANAGER_EXCLUSION_ACTIVITIES_RESPONSE_UPDATE",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "MANAGER_EXCLUSION_ACTIVITIES_RESPONSE_UPDATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* patchCurationManagerExclusionActivitiesAll(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const formData = { ...actions.form };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(formData),
    };
    let url = `${apiUrl}/opa-curation-manager-activities-bulk`;

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";
    if (response.length > 0) {
      responseStatus = "success";
    } else {
      responseStatus = "error";
    }

    yield put({
      type: "MANAGER_EXCLUSION_ACTIVITIES_ALL_RESPONSE",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "MANAGER_EXCLUSION_ACTIVITIES_ALL_RESPONSE",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

export function* getSagaCurationProductsList() {
  yield takeEvery("GET_LIST_CURATION_PRODUCTS", getCurationProductsList);
}

export function* getSagaCurationProductId() {
  yield takeEvery("GET_CURATION_PRODUCT_ID", getCurationProductId);
}

export function* getSagaCurationFeaturedList() {
  yield takeEvery(
    "GET_LIST_CURATION_FEATURED_ACTIVITIES",
    getCurationFeaturedList
  );
}

export function* getSagaCurationFeaturedId() {
  yield takeEvery("GET_CURATION_FEATURED_ACTIVITIES_ID", getCurationFeaturedId);
}

export function* addSagaCurationFeaturedActivity() {
  yield takeEvery(
    "ADD_CURATION_FEATURED_ACTIVITY",
    addCurationFeaturedActivity
  );
}

export function* updateSagaCurationFeaturedActivity() {
  yield takeEvery(
    "UPDATE_CURATION_FEATURED_ACTIVITY",
    updateCurationFeaturedActivity
  );
}

export function* deleteSagaCurationFeaturedActivity() {
  yield takeEvery(
    "DELETE_CURATION_FEATURED_ACTIVITY",
    deleteCurationFeaturedActivity
  );
}

export function* getSagaCurationExcludedList() {
  yield takeEvery(
    "GET_LIST_CURATION_EXCLUDED_ACTIVITIES",
    getCurationExcludedList
  );
}

export function* getSagaCurationExcludedId() {
  yield takeEvery("GET_CURATION_EXCLUDED_ID", getCurationExcludedId);
}

export function* addSagaCurationExcludedActivity() {
  yield takeEvery(
    "ADD_CURATION_EXCLUDED_ACTIVITY",
    addCurationExcludedActivity
  );
}

export function* deleteSagaCurationExcludedActivity() {
  yield takeEvery(
    "DELETE_CURATION_EXCLUDED_ACTIVITY",
    deleteCurationExcludedActivity
  );
}

export function* addSagaCurationExcludedActivitiesAll() {
  yield takeEvery(
    "ADD_CURATION_EXCLUDED_ACTIVITIES_ALL",
    addCurationExcludedActivitiesAll
  );
}

export function* deleteSagaCurationExcludedActivitiesAll() {
  yield takeEvery(
    "DELETE_CURATION_EXCLUDED_ACTIVITIES_ALL",
    deleteCurationExcludedActivitiesAll
  );
}

export function* addSagaCurationFeaturedActivitiesAll() {
  yield takeEvery(
    "ADD_CURATION_FEATURED_ACTIVITIES_ALL",
    addCurationFeaturedActivitiesAll
  );
}

export function* deleteSagaCurationFeaturedActivitiesAll() {
  yield takeEvery(
    "DELETE_CURATION_FEATURED_ACTIVITIES_ALL",
    deleteCurationFeaturedActivitiesAll
  );
}

export function* updateSagaCurationManagerExclusionActivities() {
  yield takeEvery(
    "UPDATE_CURATION_MANAGER_EXCLUDED_ACTIVITIES",
    updateCurationManagerExclusionActivities
  );
}

export function* getSagaCurationManagerExclusionActivitiesList() {
  yield takeEvery(
    "GET_LIST_CURATION_MANAGER_EXCLUDED_ACTIVITIES",
    getCurationManagerExclusionActivitiesList
  );
}


export function* getSagaCurationManagerActivitiesList() {
  yield takeEvery(
    "GET_LIST_CURATION_MANAGER_ACTIVITIES",
    getCurationManagerActivitiesList
  );
}

export function* getSagaCurationManagerExclusionActivitiesAll() {
  yield takeEvery(
    "PATCH_ALL_CURATION_MANAGER_EXCLUDED_ACTIVITIES",
    patchCurationManagerExclusionActivitiesAll
  );
}
